import { render, staticRenderFns } from "./CharityIndexView.vue?vue&type=template&id=670b5fa0&scoped=true"
import script from "./CharityIndexView.vue?vue&type=script&lang=js"
export * from "./CharityIndexView.vue?vue&type=script&lang=js"
import style0 from "./CharityIndexView.vue?vue&type=style&index=0&id=670b5fa0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670b5fa0",
  null
  
)

export default component.exports